import React from "react";
import { Spin, Alert } from 'antd';

const Loading = ({visible}) => {
    if(!visible) return null;
        return <div className="loading-spin"><Spin tip="Loading"></Spin></div>
}

export default Loading